import React, { Component } from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Typography from "@material-ui/core/Typography";

import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Colors from "../../constants/Colors";

const styles = {
  button: {
    background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
    borderRadius: 3,
    border: 0,
    color: "white",
    height: 48,
    padding: "0 30px",
    boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)"
  },
  buttonBlue: {
    background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
    boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)"
  },
  selected: {
    color: Colors.main
  }
};

class MenuTab extends Component {
  render() {
    const {
      classes,
      currentRoute,
      route,
      path,
      component,
      icon,
      hasAccess,
      children,
      text
    } = this.props;

    if (hasAccess) {
      return (
        <ListItem button component={Link} to={path || route}>
          <ListItemIcon style={currentRoute === route ? styles.selected : null}>
            {icon}
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography
                style={currentRoute === route ? styles.selected : null}
              >
                {text}
              </Typography>
            }
          />
        </ListItem>
      );
    }
    return null;
  }
}

export default withStyles(styles)(MenuTab);
